import React from "react";
import PropTypes from "prop-types";
import { Div, H1, P, Ul, Li, Img, Button } from "glamorous";
import PreviewRead from "./Preview/Read";
import icons from "../../imgs/icons";
import data from "../../data";
import styles from "../../styles";
import { track } from '../../misc/utils';

import ScrollFixedContainer from "../common/ScrollFixedContainer";

const getButtons = showBorder => {
  const list = [
    {
      title: data.copy("editorTextBtn"),
      name: "EditorText",
      icon: icons.editTextWhite
    },
    {
      title: data.copy("editorFiltersBtn"),
      name: "EditorFilter",
      icon: icons.editFiltersWhite
    }
  ];
  return list;
};

const makeNewText = () => {
  return {
    value: '',
    colour: "#DFC898",
    fontFamily: "JWSansBook",
    fontSize: 31,
    x: 0,
    y: 0,
    lines: 1,
    prevState: {
      x: 0,
      y: 0,
      colour: "#DFC898",
      fontFamily: "JWSansBook",
      fontSize: 22,
    }
  }
}

class EditorSimple extends React.Component {
  render() {
    const {
      images,
      setArea,
      handlePreviewMyBottle,
      setSelectedText,
      addText,
      label
    } = this.props;

    let previewWrapperRef = null;

    return (
      <Div className="container">
        <H1 css={styles.editor.title}>{data.copy("editorHeading")}</H1>
        <Div css={styles.editor.columnWrapper}>
          <ScrollFixedContainer>
            <Div
              innerRef={el => (previewWrapperRef = el)}
              css={styles.editMain.previewWrapper}
            >
              <PreviewRead
                label={label}
                handleTextClick={(textObj) => {
                  setSelectedText(null, label.text.indexOf(textObj));
                  setArea('EditorText');
                }}
              />
            </Div>
          </ScrollFixedContainer>
          <Div css={styles.editor.rightCol}>
            <Div css={styles.editor.boxShadow}>
              <P css={styles.editor.instructionalCopy}>{data.copy("editorSubHeading")}</P>
              <Ul css={styles.editMain.buttons} listStyleType="none" padding="0">
                {getButtons(images.origin.uploaded).map((button, index) => (
                  <Li
                    onClick={() => {
                      const area = button.name || button.title;

                      // horrible hack
                      if (area === 'EditorText') {
                        addText(makeNewText());
                        setSelectedText(null, label.text.length);
                      }
                      setArea(area);
                    }}
                    css={styles.editMain.button}
                    key={`edit-button_${index}`}
                  >
                    <Div css={styles.editMain.buttonTop}>
                      <Img css={styles.editMain.buttonIcon} src={button.icon}/>
                    </Div>
                    <Div css={styles.editMain.buttonText}>
                      <P css={styles.editMain.buttonTitle}>{button.title}</P>
                    </Div>
                  </Li>
                ))}
              </Ul>
              <Button
                onClick={() => {
                  const {width, height} = previewWrapperRef.getBoundingClientRect();
                  handlePreviewMyBottle(width, height);
                }}
                marginTop="15px"
                css={styles.ctas.initial}
              >
                {data.copy("editorPreviewBtn")}
              </Button>
              <Button
                onClick={() => {
                  track.event('button', 'click', 'editor_simple_start_again');
                  this.props.resetLabel();
                }}
                marginTop="10px"
                css={styles.ctas.outline}
              >
                {data.copy("editorStartBtn")}
              </Button>
            </Div>
          </Div>
        </Div>
      </Div>
    );
  }
}

EditorSimple.propTypes = {
  images: PropTypes.object.isRequired,
  label: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
  setArea: PropTypes.func.isRequired,
  setLoading: PropTypes.func.isRequired,
  handlePreviewMyBottle: PropTypes.func.isRequired
};

export default EditorSimple;



// WEBPACK FOOTER //
// ./src/components/areas/EditorSimple.js